export default {
  breach: 'breach',
  breachPlus: 'breachPlus',
  cpp: 'cpp',
  credit_expert: 'creditExpert',
  identity: 'identityPlus',
  basic: 'free',
};
